import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import Stats from './pages/Stats';
import FacturesPage from './pages/FacturesPage';
import FicheSejour from './pages/FicheSejourPage';
import DynamicChartPage from './pages/DynamicChartPage';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/stats" element={<Stats />} />
        <Route path="/dynamicChartPage" element={<DynamicChartPage />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/factures" element={<FacturesPage />} />
        <Route path="/fiche-sejour" element={<FicheSejour />} />
      </Routes>
    </Router>
  );
}


